import React,{useState} from 'react'
import TabNavItem from '../common/tabs/TabNavItem'
import TabContent from '../common/tabs/TabContent'
import EmailProcessTable from './EmailProcessTable'
import SmsProcessTable from './SmsProcessTable'
import CallProcessTable from './CallProcessTable'

function ProcessTabContainer() {
    const [activeTab,setActiveTab] = useState('email-tab')
  return (
   <>
    <div className="">
        <nav className="nav nav-tabs me-3">
            <TabNavItem
                id="email-tab"
                title="Email"
                icon="bi bi-envelope"
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
             <TabNavItem
                id="sms-tab"
                title="Sms"
                icon="bi bi-chat-dots"
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
             <TabNavItem
                id="call-tab"
                title="Telephone"
                icon="bi bi-phone"
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </nav>
        <div className="tab-content p-2 pt-3 bg-white">
            <TabContent id="email-tab" activeTab={activeTab}>
               <EmailProcessTable/>
            </TabContent>
            <TabContent id="sms-tab" activeTab={activeTab}>
                <SmsProcessTable/>
                </TabContent>
                <TabContent id="call-tab" activeTab={activeTab}>
               <CallProcessTable/>
                </TabContent>
        </div>
    </div>
   </>
  )
}

export default ProcessTabContainer